<template>
  <div id="channelLogin-login" class="login">
    <van-nav-bar
      class="login-nav"
      title="授权登录"
      :z-index="10"
      :left-arrow="false"
    ></van-nav-bar>

    <div class="top-area">
      <img
        src="../../assets/img/tiananjs-logo-2.png"
        fit="cover"
        class="top-logo"
      />
    </div>

    <!--验证码登录-->
    <van-field v-model="mobile" type="tel" maxlength="11" readonly />

    <van-cell class="home-footer">
      <van-button
        class="confirm-login"
        type="danger"
        size="large"
        @click="onSMSLogin"
        >确认授权登录</van-button
      >
      <div class="read-and-agree-box">
        <van-checkbox
          class="read-and-agree"
          v-model="consent_agreement"
          shape="square"
          checked-color="#C1A76A"
        >
          <span class="rar-1">{{ text }} 阅读并同意 </span
          ><span @click.stop="showAgreement()"
            >《天安金交中心服务协议-个人会员版》</span
          >
        </van-checkbox>
      </div>
    </van-cell>
  </div>
</template>

<script>
import {
  Checkbox,
  Button,
  Field,
  Image,
  Icon,
  Cell,
  CellGroup,
  NavBar,
  Popup,
  Toast,
  Dialog,
} from 'vant'

import * as CustApi from '@/api/cust'
import storage from '@/utils/storage'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Image.name]: Image,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
  },

  data() {
    return {
      text: '',
      mobile: '',
      consent_agreement: false, // 阅读并同意相关协议
      services_agreement: false, // 服务协议
      privacy_agreement: false, // 隐私协议
      agreement_title: '',
      agreement_content: '',
      loginForm: {
        loading: false,
        field: {
          code: '',
        },
      },
    }
  },

  computed: {
    ...mapGetters(['userAgreementLogin', 'channel', 'token']),
  },

  beforeMount() {
    this.$emit('notify')
    this.loginForm.field.code = this.$route.query.code
    CustApi.getauthphone({ code: this.loginForm.field.code })
      .then((data) => {
        this._dismissLoading()
        this.mobile = data.phone
        this.text = data.text
      })
      .catch((e) => {
        this._dismissLoading()
        Toast(e.msg || e.message)
      })

    this.consent_agreement = !!this.userAgreementLogin
    this.setUserAgreementLogin('')
  },

  methods: {
    // 查看服务协议
    showAgreement() {
      this.setUserAgreementLogin(this.consent_agreement)
      this.$router.push({ name: 'agreement-reg' })
    },

    onSMSLogin() {
      if (!this.consent_agreement) {
        Toast('请阅读并同意协议！')
        return
      }
      this._showLoading()
      console.log(this.loginForm)
      CustApi.confirmauth({ code: this.loginForm.field.code })
        .then((data) => {
          this._dismissLoading()
          this.setToken(data)
          this.onGetUserInfo()
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },

    onGetUserInfo() {
      this.getUserInfo()
        .then((data) => {
          storage.setJson(
            'cache-info',
            Object.assign({}, data, {
              mobile: this.mobile,
            })
          )
          this.$router.replace({
            name: 'callback',
            query: { ...this.$route.query, token: this.token, notified: 1 },
          })
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },
    ...mapMutations(['setToken', 'setUserInfo', 'setUserAgreementLogin']),
    ...mapActions(['getUserInfo']),
  },
}
</script>

<style lang="less" scoped>
@import './idx.less';

.read-and-agree {
  ::v-deep .van-checkbox__icon {
    position: relative;
    top: -24px;
  }
}
</style>
